import {
  Heading24,
  PurpleLinkStyled,
} from 'approot/shared/styles/typography.style';
import { PRIVATE_MY_STUDENTS } from 'global/private-routes.constants';
import { getUserClassPath } from 'approot/classes/classes.apollo';
import * as Styled from './class-answer-empty.style';

export const ClassAnswerNoStudents = () => {
  return (
    <Styled.ClassResponseEmpty>
      <Heading24 textAlignCenter marginBottom={12}>
        You haven’t added students to this class yet.
      </Heading24>
      <Styled.ClassResponseEmptyText>
        Go to the{' '}
        <PurpleLinkStyled
          to={getUserClassPath(PRIVATE_MY_STUDENTS)}
          $fontInherit
        >
          My Students
        </PurpleLinkStyled>{' '}
        page to add them, then Assign this activity to them to see their
        responses here.
      </Styled.ClassResponseEmptyText>
    </Styled.ClassResponseEmpty>
  );
};

export const ClassAnswerNoAnswers = () => {
  return (
    <Styled.ClassResponseEmpty>
      <Heading24 textAlignCenter marginBottom={12}>
        No responses here just yet
      </Heading24>
      <Styled.ClassResponseEmptyText>
        Assign this activity to your students to start seeing individual
        answers.
      </Styled.ClassResponseEmptyText>
    </Styled.ClassResponseEmpty>
  );
};
